import { render, staticRenderFns } from "./MilestonPage.vue?vue&type=template&id=60aee0b4&scoped=true"
import script from "./MilestonPage.vue?vue&type=script&lang=js"
export * from "./MilestonPage.vue?vue&type=script&lang=js"
import style0 from "./MilestonPage.vue?vue&type=style&index=0&id=60aee0b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aee0b4",
  null
  
)

export default component.exports